export const hasSpecialSymbolRegex = /[!@#$%^&*()\-=_+[\]{}|\\:;"'<>,.?/]/;
